<!-- <div [ngClass]="{ 'c-autoError--hidden': hide }">
  <p *ngIf="autoError" class="c-autoError__errorMessage">
    {{ autoError.fieldNameTranslation }}
    {{ autoError.errorTranslation }} {{ autoError.values}}
  </p> -->
<!-- </div> -->

<div [ngClass]="{ 'c-autoError--hidden': hide }">
  <div
    class="error-message"
    *ngIf="autoError"
    class="c-autoError__errorMessage"
  >
    {{ autoError.errorTranslation }} {{ autoError.values }}
  </div>
</div>
